var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import DixaIcon from '@dixa/dixa-modern-icons';
import classnames from 'classnames';
import { PureComponent } from 'react';
import styles from './messageWidgetInput.module.scss';
export class MessageWidgetInput extends PureComponent {
    render() {
        const _a = this.props, { className, label, placeholder } = _a, otherProps = __rest(_a, ["className", "label", "placeholder"]);
        const rootClass = classnames({
            [styles.root]: true,
        }, className);
        return (_jsxs("div", Object.assign({}, otherProps, { className: rootClass }, { children: [_jsx("span", Object.assign({ className: styles.label }, { children: label })), _jsxs("div", Object.assign({ className: styles.input }, { children: [_jsx("span", Object.assign({ className: styles.placeholder }, { children: placeholder })), _jsx(DixaIcon, { className: styles.icon, icon: "arrow-square-right" })] }))] })));
    }
}
